import React from 'react';
import { useTimer } from '../contexts/TimerContext.tsx';
import './TimerDisplay.css';

interface TimerDisplayProps {
  currentTaskName?: string | null;
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({ currentTaskName }) => {
  const { timeLeft, currentTab, getTimerDuration } = useTimer();
  const totalTime = getTimerDuration(currentTab);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const radius = 120;
  const circumference = 2 * Math.PI * radius;
  const progress = ((totalTime - timeLeft) / totalTime) * circumference;

  const getSessionDisplayName = (type: string) => {
    switch (type) {
      case 'pomodoro':   return 'Work';
      case 'shortBreak': return 'Short Break';
      case 'longBreak':  return 'Long Break';
      default:           return 'Work';
    }
  };

  const getSessionColor = (type: string) => {
    switch (type) {
      case 'pomodoro':   return 'var(--kf-work)';
      case 'shortBreak': return 'var(--kf-break)';
      case 'longBreak':  return 'var(--kf-long-break)';
      default:           return 'var(--kf-work)';
    }
  };

  return (
    <div className="timer-display">
      <div className="timer-circle">
        <svg width="100%" height="100%" viewBox="0 0 280 280">
          <circle cx="140" cy="140" r={radius} fill="none" style={{ stroke: 'var(--kf-surface-2)' }} strokeWidth="8" />
          <circle
            cx="140"
            cy="140"
            r={radius}
            fill="none"
            style={{ stroke: getSessionColor(currentTab) }}
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            strokeLinecap="round"
            transform="rotate(-90 140 140)"
            className="progress-circle"
          />
        </svg>
        <div className="timer-content">
          <div className="timer-level">
            <div className="level-text">Session Type</div>
            <div className="session-type" style={{ color: getSessionColor(currentTab) }}>
              {getSessionDisplayName(currentTab)}
            </div>
          </div>
          {currentTaskName && (
            <div className="current-task-display">
              <div className="task-label">Current Task</div>
              <div className="task-name">{currentTaskName}</div>
            </div>
          )}
          <div className="timer-time" style={{ color: getSessionColor(currentTab) }}>
            {formatTime(timeLeft)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimerDisplay;
